import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import thumbUpImg from "../images/icons8-thumbs-up-50.png";

const ThankYouRealEstate = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (window.fbq) {
            window.fbq('init', '908807021962260');
            window.fbq('track', 'Lead');
        }
    }, []);

    return (
        <div className="flex h-screen w-full font-poppins selection:bg-[#3E88FF] selection:text-white">
            {/* Structural Split Layout matching the Contact form */}

            {/* Left Pane (Dark) */}
            <div className="hidden md:flex flex-col w-1/3 bg-[#0b1324] relative overflow-hidden p-12 justify-center border-r border-slate-800">
                <div className="absolute inset-0 opacity-[0.03] bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>

                <div className="relative z-10">
                    <div className="h-1 w-12 bg-[#3E88FF] mb-6"></div>
                    <h2 className="text-slate-400 text-sm tracking-widest uppercase font-bold mb-4">Request Status</h2>
                    <h1 className="text-4xl text-white font-light font-serif tracking-wide leading-tight">
                        Successfully <br /><strong className="font-bold">Received.</strong>
                    </h1>
                </div>

                {/* Footer branding */}
                <div className="absolute bottom-12 left-12">
                    <h1 className="text-white/50 text-3xl font-anton tracking-widest cursor-pointer hover:text-white transition-colors flex items-baseline" onClick={() => navigate("/")}>
                        DUMOSH<span className="h-2 w-2 bg-[#FF3E3E] rounded-full ml-1"></span>
                    </h1>
                </div>
            </div>

            {/* Right Pane (Light) */}
            <div className="flex-1 bg-white relative flex flex-col justify-center px-8 md:px-20 lg:px-32 relative overflow-hidden">
                {/* Mobile Header */}
                <div className="absolute top-8 left-8 md:hidden">
                    <h1 className="text-slate-900 text-3xl font-anton tracking-widest cursor-pointer flex items-baseline" onClick={() => navigate("/")}>
                        DUMOSH<span className="h-2 w-2 bg-[#FF3E3E] rounded-full ml-1"></span>
                    </h1>
                </div>

                <div className="max-w-xl w-full">
                    <img
                        src={thumbUpImg}
                        alt="thumbs-up"
                        className="w-16 mb-10 filter grayscale hover:grayscale-0 transition-all duration-500 opacity-80"
                    />

                    <h1 className="text-4xl md:text-5xl font-light text-slate-800 tracking-tight mb-4">
                        Thank <strong className="font-bold">You</strong>
                    </h1>
                    <p className="text-xl text-slate-500 font-medium mb-12">
                        Your details are submitted. Now the real work begins.
                    </p>

                    <div className="border border-slate-200 rounded-sm p-8 bg-slate-50/50 mb-10 relative">
                        <span className="absolute -top-3 left-6 bg-white px-2 text-xs font-bold uppercase tracking-widest text-[#3E88FF]">Next Steps</span>

                        <ul className="space-y-6">
                            <li className="flex items-start">
                                <div className="w-1.5 h-1.5 bg-slate-400 rounded-full mt-2 mr-4 shrink-0"></div>
                                <p className="text-slate-600">You'll receive a call/WhatsApp from a DUMOSH expert.</p>
                            </li>
                            <li className="flex items-start">
                                <div className="w-1.5 h-1.5 bg-slate-400 rounded-full mt-2 mr-4 shrink-0"></div>
                                <p className="text-slate-600">We'll understand your goals + current funnel.</p>
                            </li>
                            <li className="flex items-start">
                                <div className="w-1.5 h-1.5 bg-slate-400 rounded-full mt-2 mr-4 shrink-0"></div>
                                <p className="text-slate-600">We'll share a clear action plan to improve conversions.</p>
                            </li>
                        </ul>
                    </div>

                    <div className="flex items-center text-slate-500 text-sm font-medium mb-8 bg-amber-50/50 p-4 border-l-2 border-amber-300">
                        <span><strong className="text-slate-700">To speed things up:</strong> keep your phone available.</span>
                    </div>

                    <button
                        className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white px-10 py-3 uppercase tracking-widest text-xs font-bold transition-all duration-300"
                        onClick={() => navigate("/interactive-realestate")}
                    >
                        Back to Assessment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ThankYouRealEstate;
